<template lang="pug">
  .partner-network
      .partner-network__wrap.partner-network__wrap_sb
          .partner-network__wrap
              .how_iconR
                  img.partner-network__photo(src=`../../../assets/images/partner_photo_11.png`, alt="" v-if="!englishVersion && !mexicoVersion")
                  img.partner-network__photo(src=`../../../assets/images/girl_usa.png`, alt="" v-if="englishVersion || mexicoVersion")
              .partner-network__content
                  .partner-network__title( v-if="!englishVersion && !mexicoVersion") Irina
                      br
                      |Umanskaya
                  .partner-network__title( v-if="englishVersion || mexicoVersion") Sandra
                      br
                      |G.
                  .partner-network__subtitle Master
          .partner-network__wrap
              //- .how_iconB
              .how_iconR
                  img.partner-network__photo(src=`../../../assets/images/partner_photo_12.png`, alt="")
              .partner-network__content
                  .partner-network__title(v-if="!englishVersion && !mexicoVersion") Gennady
                      br
                      |Pinchuk
                  .partner-network__title( v-if="englishVersion || mexicoVersion") Joseph
                      br
                      |O.
                  .partner-network__subtitle Master
      svg.svg.wow
          <line class="svg_line1 wow" x1="0" y1="0" x2="0" y2="40" style="stroke: #e5e7ea; stroke-width: 1px;" />
          <line data-wow-delay='0.25s' class="svg_line2 wow" x1="0" y1="20" x2="176" y2="20" style="stroke: #e5e7ea; stroke-width: 1px;"  />
          <line data-wow-delay='0.75s' class="svg_line3 wow" x1="176" y1="20" x2="176" y2="40" style="stroke: #e5e7ea; stroke-width: 1px;" />
          <line data-wow-delay='0.75s' class="svg_line3 wow" x1="176" y1="20" x2="176" y2="-40" style="stroke: #e5e7ea; stroke-width: 1px;" />
      .partner-network__wrap.partner-network__wrap_sb
          .partner-network__wrap
              .how_iconR
                  img.partner-network__photo.how_iconR(src=`../../../assets/images/partner_photo_13.png`, alt="" v-if="!englishVersion && !mexicoVersion")
                  img.partner-network__photo.how_iconR(src=`../../../assets/images/man_usa.png`, alt="" v-if="englishVersion || mexicoVersion")
              .partner-network__content
                  .partner-network__title(v-if="!englishVersion && !mexicoVersion") Vladimir
                      br
                      |Novikov
                  .partner-network__title(v-if="englishVersion || mexicoVersion") Atikur
                       br
                       |R.
                  .partner-network__subtitle Master
          .partner-network__wrap
              .how_iconR
                  img.partner-network__photo(src=`../../../assets/images/partner_photo_14.png`, alt="")
              .partner-network__content
                  .partner-network__title(v-if="!englishVersion && !mexicoVersion") Maria
                      br
                      |Volkova
                  .partner-network__title(v-if="englishVersion || mexicoVersion") Lenka
                      br
                      |K.
                  .partner-network__subtitle Master
</template>

<script>

export default {
}
</script>
